import Axios, { CancelToken, CancelTokenSource } from 'axios';
import { nanoid } from 'nanoid/non-secure';

const requests: { [key: string]: CancelTokenSource } = {};
export const CANCEL_MESSAGE = 'cancel';

export const createToken = (): { cancelId: string; token: CancelToken } => {
  const source = Axios.CancelToken.source();
  const cancelId = nanoid();

  requests[cancelId] = source;

  return { token: source.token, cancelId };
};

export const removeToken = (cancelId: string): void => {
  delete requests[cancelId];
};

export const cancelById = (cancelId: string): void => {
  requests[cancelId]?.cancel(CANCEL_MESSAGE);
};
